<template lang="html">
  <div class="container mt-5" style="height: calc(100vh - 3rem)">
    <editor
        :tools="[]"
        :immutables="true"
        :value="htmlText"
        style="height: calc(100% - 1rem); width: 100%"
        rows="10"
        cols="30"
    >
    </editor>
  </div>
</template>
<script>
import '@progress/kendo-ui/js/kendo.editor'
import {Editor} from "@progress/kendo-editor-vue-wrapper";
import {http} from "../interceptor/http-interceptor";

export default {
    name: "Contract",
    components: {
        editor: Editor,
    },
    data() {
        return {
            htmlText: "",
            guidDocumento: "",
        };
    },
    mounted() {
        const editor = document.querySelector(".k-content");
        editor.contentWindow.document.body.setAttribute("contenteditable", "false");
        this.guidDocumento = this.$route.params.id;
        this.GetDocument();
    },
    methods: {
        async GetDocument() {
            const loader = this.$loading.show();
            try {
                const request = await http.get(`/Document/Contract/${this.guidDocumento}`);
                this.htmlText = await request.data;
                loader.hide();
            } catch (error) {
                console.log(error);
                loader.hide();
            }
        },
    },
};
</script>
<style lang="scss">

.k-content {
  height: calc(100vh - 4rem)!important;
}

.k-toolbar.k-editor-toolbar {
  display: none;
}

</style>
